exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payout-statbox-amount{font-family:\"EB Garamond\",sans-serif;font-size:2.5rem;font-weight:500}.payout-statbox-notes{font-style:italic;font-size:.7rem;color:#8c96a3}.stat-box-card{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:8px;min-height:160px;min-width:280px;padding:20px;border-radius:5px;background-color:#fff;box-shadow:0 0 0 1px rgba(63,63,68,.05),0 3px 5px 0 rgba(63,63,68,.15)}.stat-box-header{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;gap:8px}.gap-1{gap:8px}.gap-2{gap:16px}.gap-3{gap:24px}.gap-4{gap:32px}.gap-5{gap:40px}.gap-6{gap:48px}.stat-box-container{display:-ms-grid;display:grid;-ms-grid-columns:(minmax(280px, 1fr))[auto-fit];grid-template-columns:repeat(auto-fit, minmax(280px, 1fr))}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/statbox/styles/styles.scss
// module id = 5985
// module chunks = 0